/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { TabCoordinatorService } from './@core/service/tab-coordinator.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  isMasterTab: boolean;

  constructor(private analytics: AnalyticsService, private tabCoordinatorService: TabCoordinatorService) {
    this.isMasterTab = this.tabCoordinatorService.isMasterTab;
  }
  
  ngOnInit(): void {
    this.analytics.trackPageViews();
  }
}
